import { MinLeasedTermService } from './min-leased-term.service';
import { OfferedSpaceService } from './offered-space.service';
import { ResearchAvailabilityService } from './research-availability.service';
import { ResearchDevelopmentPipelineService } from './research-development-pipeline.service';
import { ReportContactsService } from './report-contacts.service';

/**
 * Available custom data retrievers options. This should be passed to the
 * {@link TemplateField} from the blueprint.
 *
 * @see TemplateField.customDataService
 */
export enum CustomDataRetrievers {
  offeredSpace = 'offered-space',
  minLeasedTerm = 'min-leased-term',
  researchAvailability = 'research-availability',
  researchDevelopmentPipeline = 'research-development-pipeline',
  reportContacts = 'report-contacts',
}

export const CustomDataRetrieversServicesMap = {
  [CustomDataRetrievers.offeredSpace]: OfferedSpaceService,
  [CustomDataRetrievers.minLeasedTerm]: MinLeasedTermService,
  [CustomDataRetrievers.researchAvailability]: ResearchAvailabilityService,
  [CustomDataRetrievers.researchDevelopmentPipeline]: ResearchDevelopmentPipelineService,
  [CustomDataRetrievers.reportContacts]: ReportContactsService,
};
